import React from 'react';
import { useNavigate } from 'react-router-dom';
import FileUpload from '../components/FileUpload';
import type { FileInfo } from '../types';

const AnalysisUpload: React.FC = () => {
  const navigate = useNavigate();

  const handleUploadSuccess = (fileInfo: FileInfo) => {
    navigate(`/analysis/data-select?fileId=${fileInfo.file_id}`);
  };

  return (
    <FileUpload
      onUploadSuccess={handleUploadSuccess}
      title="上传数据，深度分析。"
      subtitle="上传表格后系统自动识别数据拓扑，推荐最适合的统计分析模块。"
    />
  );
};

export default AnalysisUpload;
